import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  min-height: 85vh;
  background-color: #fff;
`;
export const ContentContainer = styled.div`
  width: 100%;
  height: auto;
  text-align: left;
  display: flex;
  flex-direction: column;
  p,
  h1 {
    max-width: 90%;
    margin: 1rem auto;
    width: 90%;
  }
  video,
  img {
    max-width: 90%;
    width: 90%;
    margin: 1rem auto;
  }
  .publishDate {
    color: #757575;
    font-style: italic;
    font-size: 1rem;
    font-size: 12px;
    text-align: left;
  }
  .galery-container {
    width: 90%;
    margin: auto;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    img {
      width: 90%;
      margin: auto;
    }
  }
  @media only screen and (min-width: 768px) {
    p,
    h1 {
      max-width: 40%;
      width: 40%;
    }
    video,
    img {
      max-width: 70%;
      width: 70%;
    }
    .galery-container {
      flex-direction: row;
      justify-content: space-between;
      div {
        width: 48%;
        p {
          width: fit-content;
          margin: 1rem auto;
        }
        img {
          width: 100%;
          max-width: unset;
        }
      }
    }
  }
`;
export const SideContainer = styled.div`
  width: 20%;
  height: 100%;
  position: sticky;
  top: 0;
  padding: 0 2rem;
  .author {
    color: #757575;
    span {
      color: #000;
    }
  }
  h4,
  button {
    display: none;
  }
`;
export const RelatedPosts = styled.div`
  width: 100%;
  background-color: red;
`;
export const PublishDateText = styled.p`
  color: #757575;
  font-style: italic;
`;
export const ReturnContainer = styled.div`
  display: block;
  width: 100%;
  align-self: center;
  padding: 2rem 0;
  text-align: center;
  a {
    text-decoration: none;
    color: #c3973f;
    &::before {
      content: "←";
      padding-right: 2rem;
    }
  }
  &:hover {
    background-color: #f5f5f5;
  }
  @media only screen and (min-width: 768px) {
    padding: 5rem 0;
  }
`;
